import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { systemPropertyOwnershipStatus } = loanFormModel.formField;

class IsPropertyLeased implements Rule {
  get dependsOn(): string[] {
    return [systemPropertyOwnershipStatus.name];
  }
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    return application[systemPropertyOwnershipStatus.name] === 'LEASED';
  }
}

export default new IsPropertyLeased();
